import React, { CSSProperties } from 'react';
import { Typography } from '@mui/material';
import colors from 'src/styles/equalution/colors';

interface MoneybackGuaranteeProps {
  color?: string;
  align?: 'left' | 'center' | 'right' | 'justify';
  style?: CSSProperties;
}

export const MoneybackGuarantee: React.FC<MoneybackGuaranteeProps> = ({
  color = colors.SALAD,
  align = 'left',
  style,
}) => {
  return (
    <Typography
      sx={{
        color,
        textAlign: align,
        fontSize: '14px',
        fontWeight: 600,
        width: '100%',
        ...style,
      }}>
      7 day money back guarantee
    </Typography>
  );
};

export default MoneybackGuarantee;
